export const CONTROL_TYPES = Object.freeze({
  BRIGHTNESS: 'BRIGHTNESS',
  CONTRAST: 'CONTRAST',
  ROTATE_CLOCKWISE: 'ROTATE_CLOCKWISE',
  ROTATE_COUNTER_CLOCKWISE: 'ROTATE_COUNTER_CLOCKWISE',
  ROTATE: 'ROTATE',
  ZOOM: 'ZOOM',
  UNDO: 'UNDO',
  REDO: 'REDO',
  FIT_TO_SCREEN: 'FIT_TO_SCREEN'
});